import { data } from '../../svg/FormatListBulleted/data';
import { makeIcon } from '../makeIcon';

export const FormatListBulleted = makeIcon(data, 'format_list_bulleted', 'FormatListBulleted');

export default FormatListBulleted;
